const uint = 'uint';
const int = 'int';
const address = 'address';
const string = 'string';
const bytes = 'bytes';
const bool = 'bool';

export { uint, address, string, bytes, bool, int };
